import { gql, useQuery } from "@apollo/client";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ReactLoading from "react-loading";
import CelebrateSvg from "./CelebrateSvg";

const SESSION_QUERY = gql`
  query InsuranceApplicationSession($iaSession: String) {
    insuranceApplicationSession(iaSession: $iaSession) {
      isGeneralOptIn
      policies {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

const Success = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // Try to get session ID from query params or from URL path
  const iaSession = searchParams.get("session") || 
                    searchParams.get("iaSession") || 
                    searchParams.get("ia_session");
  
  const { loading, data, error } = useQuery(SESSION_QUERY, {
    variables: { iaSession },
    skip: !iaSession,
    fetchPolicy: "network-only", // Always fetch fresh data
    errorPolicy: "all", // Continue even if there's an error
  });

  const isGeneralOptIn = data?.insuranceApplicationSession?.isGeneralOptIn === true;
  const hasPolicies = data?.insuranceApplicationSession?.policies?.edges?.length > 0;
  
  // If we can't determine session type, default to showing standard message
  // This handles cases where session ID is missing or query fails
  const showGeneralOptInMessage = isGeneralOptIn === true;

  // Redirect back to the application after a short delay
  useEffect(() => {
    if (iaSession && !loading) {
      const timeoutId = setTimeout(() => {
        // Redirect back to the application
        const basePath = window.location.pathname.includes("sandbox") ? "/sandbox" : "";
        navigate(`${basePath}/${iaSession}`);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [iaSession, loading, navigate]);

  if (loading) {
    return (
      <article className="vh-100 dt w-100">
        <div className="dtc v-mid tc white ph3 ph4-l">
          <ReactLoading type={"spin"} color={"#cccccc"} className="center" />
        </div>
      </article>
    );
  }

  return (
    <article className="vh-100 dt w-100">
      <div className="dtc v-mid tc white ph3 ph4-l">
        <h1 className="f1 lh-title near-black">eSignature document signed!</h1>
        <CelebrateSvg />
        <div className="center tc mw7">
          {showGeneralOptInMessage ? (
            <p className="f3 lh-copy near-black">
              We'll automatically redirect you to complete your application. If you're not
              automatically redirected, click "Continue below".
            </p>
          ) : (
            <p className="f3 lh-copy near-black">
              We'll automatically redirect you to the "Final Review" step to review
              your coverage details and activate your coverage. If you're not
              automatically redirected, click "Continue below".
            </p>
          )}
        </div>
        {iaSession && (
          <div className="center tc mw7 mt4">
            <button
              onClick={() => {
                const basePath = window.location.pathname.includes("sandbox") ? "/sandbox" : "";
                navigate(`${basePath}/${iaSession}`);
              }}
              className="f5-ns ph4 pv3 br2 bg-black white pointer bn"
            >
              Continue
            </button>
          </div>
        )}
      </div>
    </article>
  );
};

export default Success;
